import { Button, type ButtonProps } from '@carbon/react';
import { Add } from '@carbon/react/icons';
import { useCreateDcaWorkspace } from './use-create-dca-workspace';
import style from './create-dca-workspace.module.scss';
import classNames from 'classnames';

export interface CreateDcaWorkspaceProps extends ButtonProps<'button'> {
  parentType: string;
  parentId: number;
  additionalData?: Record<string, unknown>;
  disabled?: boolean;
}

export const CreateDcaWorkspace = ({
  parentType,
  parentId,
  className,
  additionalData,
  disabled = false,
  ...props
}: CreateDcaWorkspaceProps) => {
  const { createDcaWorkspace, loading } = useCreateDcaWorkspace({
    parentType,
    parentId,
    additionalData,
  });

  return (
    <Button
      size="md"
      kind="tertiary"
      className={classNames(style.createDcaWorkspaceButton, className)}
      {...props}
      renderIcon={Add}
      disabled={loading || disabled}
      onClick={createDcaWorkspace}
    >
      Create DCA Workspace
    </Button>
  );
};
